/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum NorwegianTaxPayerType {
  M = 0,
  D = 1,
  K = 2,
}
